
import {Component, Watch, Vue} from "vue-property-decorator";
import {GuitarChordParse, IndexStringPair, SongLine} from "../chords/GuitarChordParse";
import {GuitarChordDraw} from "../chords/GuitarChordDraw";
import {CHORDS_DB} from "../chords/chords-db";
import ArtistImage from "./ArtistImage.vue";
import {store} from "../Store";
interface ChordDraw {
    name: string;
    current: number;
    max: number;
}

@Component({
    components: {ArtistImage}
})
export default class SongDetails extends Vue {

    lines: SongLine[] = [];
    chords: ChordDraw[] = [];

    data = store.data;


    created() {
        this.fetch()
    }


    get youtubeSearch() {
        const artistName = this!.data!.currentSong!.artist ? this!.data!.currentSong!.artist!.name : '';
        return encodeURIComponent(this!.data!.currentSong!.title + ', ' + artistName);
    }

    @Watch("$route")
    fetch() {
        const id: number = parseInt(this.$route.params["id"], 10);
        store.fetchCurrentSong(id);
    }

    @Watch("data.currentSong")
    prepareSong() {
        const song = this.data.currentSong;
        if (!song) return;
        const parser = new GuitarChordParse();
        parser.loadSong(song.body);
        this.lines = parser.transformSong();
        this.chords = parser.getChords()
            .filter((name: string) => name in CHORDS_DB)
            .map((name: string) => ({name, current: 0, max: CHORDS_DB[name].length - 1}));
        this.updateChords();
    }


    updateChords() {
        setTimeout(() => {
            this.$forceUpdate();
            this.$nextTick(() => {
                this.renderListOfChords();
            })
        });
    }


    renderListOfChords() {
        const canvasList = <HTMLCanvasElement[]>this.$refs.canvasList;
        if (!canvasList) {
            return;
        }
        canvasList.forEach(canvas => {
            const pos: number = parseInt(<string>canvas.getAttribute('data-pos'), 10);
            const chord = this.chords[pos];
            const positions = CHORDS_DB[chord.name][chord.current].positions.join('-');
            new GuitarChordDraw(canvas, positions);
        })
    }

    renderLineOfTabs(tabs: IndexStringPair[]): string {
        let lastAbsPos = 0;
        return tabs.map(tab => {
            const position = tab[0];
            const text = tab[1];
            const spaces = Array(position - lastAbsPos).fill(" ");
            lastAbsPos = position + text.length;
            return spaces.join("") + text;
        }).join("");
    }

    renderLine(line:any) {
        let ret = line.isTab ?  this.renderLineOfTabs(line.tabs) : line.content;
        return ret + '\n';
    }

    changePosition(chord: ChordDraw, dir: number) {
        chord.current += dir;
        this.updateChords();
    }


}
